import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

import { LoadingMenu } from '../../components/LoadingMenu';

const styles = cssMap({
	wrapper: {
		paddingTop: token('space.100'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
		width: '360px',
	},
});

const messages = defineMessages({
	loading: {
		id: 'platform.navigation-experiences.universal-create.integrations.form-loading',
		defaultMessage: 'Loading',
		description: 'loading message',
	},
});

export function FormLoading(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={cx(styles.wrapper)}>
			<LoadingMenu />
			<VisuallyHidden id={messages.loading.id}>{formatMessage(messages.loading)}</VisuallyHidden>
		</Box>
	);
}
